const onTheBeachComponent = {
    template: '<div ui-view></div>'
};

export default onTheBeachComponent;



// WEBPACK FOOTER //
// ./client/app/routes/onTheBeach/onTheBeach.component.js